import { toSentenceCase } from "global/utils/text";
import { ContainerModalToken } from "./localStyle";

const ModalToken = ({ dissmiss, mensaje }) => {
  return (
    <ContainerModalToken>
      <span>
        {mensaje
          ? toSentenceCase(mensaje)
          : "No hemos podido verificar tu token. Te pedimos por favor que lo ingreses nuevamente. "}
      </span>
      <button className="btn" onClick={dissmiss}>
        Ingresar token nuevamente
      </button>
    </ContainerModalToken>
  );
};

export default ModalToken;
